const theme = {
  fonts: {
    primary: 'arial, sans-serif',
  },
  palette: {
    primary: ['#1E90FF', '#80C0FF', '#A7D4FF', '#E2F1FF'],
    grayscale: ['#000000', '#404040', '#808080', '#A9A9A9', '#D3D3D3', '#F5F5F5', '#FFFFFF'],
    success: ['#00FF00'],
    error: ['#FF6666'],
  },
  sizes: {
    maxWidth: '1024px',
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  }
}

theme.breakpoints = [
  theme.sizes.mobile,
  theme.sizes.tablet,
]

export default theme
